import { getComparisons } from '@/utils/statScoreApi';
import get from 'lodash/get';

const defaultState = {
  comparisons: { loading: false, data: [] },
  allMatchesStats: [],
  recentMatches: [],
  homeRecentMatches: [],
  awayRecentMatches: [],
  homeNextMatches: [],
  awayNextMatches: [],
  homeTeamStatistics: [],
  awayTeamStatistics: [],
  homeTeam: {},
  awayTeam: {},
  homeTeamForm: '',
  awayTeamForm: '',
  homeTeamFormByHome: '',
  awayTeamFormByHome: '',
  homeTeamFormByAway: '',
  awayTeamFormByAway: '',
};
const state = {
  ...JSON.parse(JSON.stringify(defaultState)),
};

const getters = {};

const mutations = {
  setLoadingStatus(state, data) {
    state.comparisons = data.status
      ? { loading: data.status, data: [], error: data.error }
      : { ...state.comparisons, loading: false, error: data.error };
  },
  setDefaultState(state) {
    Object.keys(defaultState).forEach(key => {
      state[key] = defaultState[key];
    });
  },
  setComparisons(state, data) {
    return new Promise(resolve => {
      try {
        state.comparisons.data = data;
        state.homeTeamStatistics = data.HomeTeamStatistics;
        state.awayTeamStatistics = data.AwayTeamStatistics;
        state.homeTeam = get(state, 'homeTeamStatistics[0].participants[0]', {
          name: 'Home',
          id: 1,
        });
        state.awayTeam = get(state, 'awayTeamStatistics[0].participants[0]', {
          name: 'Away',
          id: 2,
        });
        state.allMatchesStats = get(data, 'MatchStat.all_matches_stats', []);
        state.recentMatches = get(data, 'RecentMatches', []);
        state.homeRecentMatches = get(data, 'HomeRecentMatches', []);
        state.awayRecentMatches = get(data, 'AwayRecentMatches', []);
        state.homeNextMatches = get(data, 'HomeRecentNotStartedMatches', []);
        state.awayNextMatches = get(data, 'AwayRecentNotStartedMatches', []);
        state.homeTeamForm = get(data, 'MatchStat.LastMatches.LastMatchesOverall.Home', '');
        state.awayTeamForm = get(data, 'MatchStat.LastMatches.LastMatchesOverall.Away', '');
        state.homeTeamFormByHome = get(data, 'MatchStat.LastMatches.LastMatchesHome.Home', '');
        state.awayTeamFormByHome = get(data, 'MatchStat.LastMatches.LastMatchesAway.Home', '');
        state.homeTeamFormByAway = get(data, 'MatchStat.LastMatches.LastMatchesHome.Away', '');
        state.awayTeamFormByAway = get(data, 'MatchStat.LastMatches.LastMatchesAway.Away', '');
        resolve();
      } catch (err) {
        console.log(err);
        reject(err);
      }
    });
  },
};

const actions = {
  getComparisons: ({ commit, rootState }, payload) => {
    commit('setDefaultState');
    commit('setLoadingStatus', { status: true });
    return getComparisons({
      selectedLang: rootState.settings.selectedLocale.short_code,
      id: payload,
    })
      .then(async res => {
        let wait = await commit('setComparisons', res.data.Data);
        commit('setLoadingStatus', { status: false });
      })
      .catch(err => {
        console.log(err);
        commit('setLoadingStatus', { status: false, error: true });
      });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
